import { useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { toast } from "react-toastify";
import { ProductContext } from "../../context/ProductContext";
import { AuthUserContext } from "../../context/AuthUserContext";
import SimpleContext from "../../context/SimpleContext";
import { cartActions } from "../../store/cart-slice";
import { saveForLaterActions } from "../../store/save-slice";
import { calculatePrice } from "../../utils/discount";
import ImageSlider from "../../components/product/ImageSlider";
import AddToCartAnim from "../../components/animations/AddToCartAnim";
import { useNavigation } from "../../utils/navigation";
import { useTranslation } from "react-i18next";
import Breadcrumbs from "../../components/section/BreadCrumbs";
import ProductDetails from "../../components/section/ProductDetails";
import descriptions from "../../descriptions.json";
import Success from "../../components/toast/Success";

const showSaveNotification = (text) => {
  toast(<Success text={text} />, {
    position: "top-left",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    className: "custom-toast-success",
    progressClassName: "custom-progress-bar",
  });
};

const Container = styled.main`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  background-color: var(--bg-100);

  padding-top: calc(
    var(--navbar-height) + var(--navbar-mini) + var(--navbar-mini)
  );
  min-height: 90vh;
  @media (min-width: 768px) {
    padding-top: calc(
      var(--navbar-height-desktop) + var(--navbar-mini) + var(--navbar-mini)
    );
  }
`;
const BreadcrumbsContainer = styled.div`
  @media (min-width: 1025px) {
    //padding: var(--spacing-md) 0 0 0;
    max-width: var(--max-width-container);
  }
  width: 94%;
`;
const TitleContainerDesktop = styled.div`
  display: none;
  @media (min-width: 1025px) {
    display: block;
  }
  width: 94%;
`;
const TitleContainerMobile = styled.div`
  width: 94%;
  @media (min-width: 1025px) {
    display: none;
  }
  display: flex;
  justify-content: center;
  margin-top: 40px;
`;
const SpecificationDesktop = styled.div`
  width: 100%;
  display: none;
  @media (min-width: 1025px) {
    display: block;
  }
`;
const SpecificationMobile = styled.div`
  width: 100%;
  @media (min-width: 1025px) {
    display: none;
  }
`;
const Wrapper = styled.div`
  padding-bottom: var(--spacing-xxl);
  width: 94%;

  @media (min-width: 768px) {
    width: 100%;
  }
  @media (min-width: 1025px) {
    max-width: var(--max-width-container);
    display: flex;
    position: relative; /* Ovo je potrebno za relativno pozicioniranje unutar roditelja */
    justify-content: flex-end;
  }
`;

const LeftContainer = styled.div`
  @media (min-width: 1025px) {
    width: 60%;
    position: sticky;
    right: calc(
      (100vw - var(--max-width-container)) / 2 + var(--max-width-container) -
        700px
    );
    top: calc(var(--navbar-height-desktop) + var(--font-size-xxlarge) + 40px);
  }
`;

const RightContainer = styled.div`
  display: flex;
  flex-direction: column;
  @media (min-width: 1025px) {
    width: calc(100% - 60% - 40px);
  }
`;
const Title = styled.h1`
  font-size: 1.6rem;
  width: 100%;
  font-weight: 700;
  letter-spacing: -0.01em;
  line-height: 1.2;
  text-align: left;

  @media (min-width: 768px) {
    padding: 0 0 var(--spacing-md) 0;
    text-align: left;
    font-size: 2.5rem;
    font-weight: 700;
  }
`;
const FlexDiv = styled.div`
  display: flex;
  gap: var(--spacing-md);
`;
const FlexDivIcons = styled(FlexDiv)`
  gap: var(--spacing-md);
  flex-direction: column;
`;

const FlexDivPrice = styled(FlexDiv)`
  margin: var(--spacing-md) 0;
  justify-content: space-between;
  gap: 20px;

  @media (min-width: 768px) {
    width: 50%;
  }
`;

const Price = styled.span`
  font-size: var(--font-size-xlarge);
  font-weight: bold;
`;

const BrT = styled.div`
  height: 1px;
  background-color: var(--text-color);
  width: 100%;
  margin: var(--spacing-lg) 0;
  opacity: 0.1;
`;

const LoadingState = styled.div`
  width: 94%;
  padding: var(--spacing-xxl) 0;
  text-align: center;
  color: var(--text-200);
`;

const StickyBar = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-md);
  padding: 10px 5%;
  background-color: var(--bg-100);
  border-top: 1px solid var(--bg-300);
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.08);
  transform: translateY(${({ $visible }) => ($visible ? "0" : "100%")});
  transition: transform 0.2s ease;
  @media (min-width: 1025px) {
    display: none;
  }
`;
const StickyBarPrice = styled.span`
  font-weight: bold;
  font-size: var(--font-size-large);
  white-space: nowrap;
  color: var(--text-100);
`;
const StickyBarButton = styled.button`
  flex: 1;
  background-color: var(--primary-200);
  color: var(--bg-200);
  font-weight: 600;
  padding: 12px 0;
  border-radius: 4px;
  &:disabled {
    background-color: var(--bg-300);
    color: var(--text-100);
    cursor: not-allowed;
  }
`;

const BuyCard = styled.div`
  background-color: var(--bg-100);
  border: 1px solid var(--bg-300);
  border-radius: 12px;
  padding: var(--spacing-lg);
  margin: var(--spacing-lg) 0;
  box-shadow: var(--shadow-medium);
`;

const GridQuantity = styled.div``;
const GridQuantityItem = styled.div`
  margin-bottom: 8px;
  font-family: "Gudea-Regural";
  font-size: var(--font-size-base);
  //padding: 8px;
  cursor: pointer;
  color: ${({ $isActive }) =>
    $isActive ? "var(--text-100)" : "var(--text-200)"};

  border: ${({ $isActive }) =>
    $isActive ? "2px solid var(--primary-200)" : "1px solid var(--bg-300)"};
  background-color: ${({ $isActive }) =>
    $isActive ? "var(--bg-100)" : "var(--bg-200)"};
  transition: border-color 0.15s ease, background-color 0.15s ease;

  //border-radius: 20px;
  text-align: center;
  text-transform: capitalize;
  width: 100%;
  min-width: 100%;

  padding: 10px 0;
  display: flex;
  align-items: center;
  justify-content: space-around;
  &:hover {
    opacity: 0.8;
  }
  &:focus-visible {
    outline: 2px solid var(--text-100);
    outline-offset: 2px;
  }

  border-radius: 4px;
`;
const QuantityItemWrapper = styled.div`
  width: 90%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const ButtonContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 9fr 1fr;
  gap: 14px;
`;

const ButtonWrapper = styled.div`
  position: relative; /* Roditeljski kontejner koji omogućava apsolutno pozicioniranje za decu */
  display: inline-block; /* Omogućava kontejneru da se prilagodi veličini sadržaja */
  width: 100%;
  text-align: center;
`;

const Button = styled.button`
  width: 100%;
  background-color: var(--primary-200);
  color: var(--bg-200);

  font-size: var(--font-size-large);
  font-weight: 100;

  &:hover {
    background-color: var(--bg-200);
    color: var(--primary-100);
  }
  &:disabled {
    background-color: var(--bg-300);
    border-color: var(--bg-300);
    color: var(--text-100);
    cursor: not-allowed;
  }
`;

const IconDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  @media (min-width: 768px) {
    gap: 4px;
  }
`;
const SVGIcon = styled.svg`
  background-color: rgba(86, 147, 191, 0.1);
  padding: 4px 8px;
  border-radius: 50%;
  min-width: 24px;
  min-height: 24px;
`;
const IconText = styled.span`
  font-size: var(--font-size-base);
  color: var(--p-color);
  padding: 0;
  margin: 0;
  @media (min-width: 768px) {
    font-size: var(--font-size-small);
  }
`;

const DescTitle = styled.h2`
  text-transform: uppercase;
  font-weight: 300;
`;
const DescText = styled.p`
  font-weight: 200;
`;

const StockBadge = styled.div`
  display: inline-flex;
  align-self: flex-start;
  align-items: center;
  gap: 7px;
  padding: 5px 12px;
  border-radius: 999px;
  font-size: var(--font-size-small);
  font-weight: 600;
  color: var(--text-100);
  margin: 4px 0 var(--spacing-md) 0;
  background-color: ${({ status }) =>
    status === "in_stock"
      ? "rgba(3, 218, 198, 0.14)"
      : status === "on_request"
      ? "rgba(255, 193, 7, 0.18)"
      : "rgba(207, 102, 121, 0.14)"};
`;
const StockBadgeDot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${({ status }) =>
    status === "in_stock"
      ? "var(--success-color)"
      : status === "on_request"
      ? "var(--warning-color)"
      : "var(--error-color)"};
`;

const GridIcons = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  margin-bottom: 14px;

  order: 3;
  @media (min-width: 768px) {
    gap: 14px;
    grid-template-columns: repeat(4, 1fr);
    margin-top: 14px;
    order: 0;
  }
`;
const GridIconsItem = styled.div`
  background-color: var(--bg-200);
  border-radius: 10px;
  border: 1px solid var(--bg-300);
  border-top: 3px solid var(--primary-200);
  box-shadow: var(--shadow-medium);
`;
const GridIconsItemWrapper = styled.div`
  margin: 0 auto;
  width: 80%;
  padding: 12px 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  gap: 8px;
`;
const TextIconsP = styled.p`
  font-size: var(--font-size-small);
  padding: 0;
  margin: 0;
`;

const RadioButton = styled.div`
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ $isActive }) =>
    $isActive ? "var(--primary-200)" : "var(--bg-100)"};
  border: 1px solid
    ${({ $isActive }) => ($isActive ? "var(--primary-200)" : "var(--text-100)")};
  border-radius: 50%;
  transition: background-color 0.15s ease, border-color 0.15s ease;
`;
const RadioInner = styled.div`
  width: 8px;
  height: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--bg-100);
  border-radius: 50%;
`;
const SVGContainer = styled.div`
  position: relative;
  cursor: pointer;
  background-color: var(--bg-100);

  padding: 4px;
  border: 1px solid var(--bg-100);

  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  transition: all 0.3s ease;
  &:hover {
    border: 1px solid var(--text-100);
    & > span {
      opacity: 1;
      visibility: visible;
      transform: translateY(0);
    }
  }
  border: 1px solid var(--bg-300);
  border-radius: 8px;
`;
const SaveForLaterSVG = styled.svg`
  cursor: pointer;
`;
const TooltipText = styled.span`
  position: absolute;
  bottom: 110%; /* Position above the icon */
  right: 0%;

  background-color: var(--text-200);
  color: var(--bg-100);
  padding: 6px 10px;
  border-radius: 4px;
  font-size: var(--font-size-small);
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: all 0.5s ease;
  z-index: 20;

  /* Optional arrow styling for the tooltip */
  &::after {
    content: "";
    position: absolute;
    top: 100%;
    right: 10%;
    transform: translateX(-50%);
    border-width: 6px;
    border-style: solid;
    border-color: var(--text-200) transparent transparent transparent;
  }
`;
const ProductMain = () => {
  const { t, i18n } = useTranslation();
  const { slug } = useParams();

  const [selectedQuantity, setSelectedQuantity] = useState(10);
  const dispatch = useDispatch();
  const {
    setIsCartOpen,

    loadProductBySlug,
    product,
    setProduct,
    currencyTag,
    loadRecommededProductsBySlug,
  } = useContext(ProductContext);
  const { authTokens } = useContext(AuthUserContext);
  const { showLoginPopup } = useContext(SimpleContext);
  const [discountedPrice, setDiscountedPrice] = useState(0);
  const [savingsPercentage, setSavingsPercentage] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [breadcrumbItems, setBreadcrumbItems] = useState([]);
  const [loadError, setLoadError] = useState(false);
  const [isMainButtonVisible, setIsMainButtonVisible] = useState(true);
  const addToCartRef = useRef(null);

  const saveForLaterItems = useSelector(
    (state) => state.saveForLater.itemsList
  );
  const isSaved = !!(
    product && saveForLaterItems.some((item) => item.product.id === product.id)
  );

  const toggleSaveForLater = () => {
    if (isSaved) {
      dispatch(saveForLaterActions.removeFromSaveForLater(product.id));
    } else {
      dispatch(
        saveForLaterActions.addToSaveForLater({
          product: {
            ...product,
            discount_price: calculatePrice(product.price, 1),
          },
          quantity: 1,
        })
      );
      showSaveNotification(t("CART.SAVED_FOR_LATER"));
    }
  };

  useEffect(() => {
    if (!slug) {
      return;
    }
    setProduct(null);
    setLoadError(false);
    const fetchProduct = async () => {
      try {
        const productData = await loadProductBySlug(slug); // Pretpostavljamo da loadProductBySlug vraća podatke o proizvodu
        setProduct(productData);
        window.scrollTo(0, 0);
      } catch (error) {
        console.error("Failed to load product:", error);
        setLoadError(true);
      }
    };

    fetchProduct();
    loadRecommededProductsBySlug(slug);
  }, [slug, i18n.language]);
  useEffect(() => {
    if (product) {
      const newDiscountedPrice = calculatePrice(
        product.price,
        selectedQuantity
      );
      setDiscountedPrice(newDiscountedPrice);

      const newSavingsPercentage = Math.round(
        ((product.price - newDiscountedPrice) / product.price) * 100
      );
      setSavingsPercentage(newSavingsPercentage);
      setBreadcrumbItems([
        { name: "SnusCo", url: "/" },
        { name: "Nicotine Pouches", url: `/${i18n.language}/snus-verkauf` },
        {
          name: `${product.name}`,
          url: "/",
        },
      ]);
    }
  }, [product, selectedQuantity]);

  const addToCart = (selectedQuantity) => {
    dispatch(
      cartActions.addToCart({
        product: product,
        quantity: selectedQuantity,
      })
    );
    setIsCartOpen(true);
    setIsAnimating(true);
  };

  const handleAnimationComplete = () => {
    setIsAnimating(false);
  };
  const getDiscountData = (quantity) => {
    const discountedPrice = calculatePrice(product.price, quantity);
    const savings = Math.round(
      ((product.price - discountedPrice) / product.price) * 100
    );
    return { discountedPrice, savings };
  };

  const [shortDesc, setShortDesc] = useState("");

  useEffect(() => {
    // Pronađi objekat za trenutni slug
    const item = descriptions.find((d) => d.slug === slug) ?? null;
    if (!item) {
      setShortDesc(t("loading"));
      return;
    }

    // Odredi jezik i ključ
    const lang = i18n.language.startsWith("sr")
      ? "sr"
      : i18n.language.startsWith("de")
      ? "de"
      : "en";
    const shortKey = `short_${lang}`;

    // Učitaj kratki opis
    setShortDesc(item[shortKey] || "");
  }, [slug, descriptions, i18n.language, t]);

  useEffect(() => {
    if (!addToCartRef.current) {
      return;
    }
    const observer = new IntersectionObserver(
      ([entry]) => setIsMainButtonVisible(entry.isIntersecting),
      { threshold: 0 }
    );
    observer.observe(addToCartRef.current);
    return () => observer.disconnect();
  }, [product]);
  return (
    <Container>
      {product && (
        <>
          <BreadcrumbsContainer>
            <Breadcrumbs breadcrumbs={breadcrumbItems} />
          </BreadcrumbsContainer>

          <Wrapper>
            <LeftContainer>
              <div style={{ position: "relative" }}>
                <ImageSlider images={product.images} productName={product.name} />
              </div>
              <TitleContainerMobile>
                <Title>{product.name}</Title>
              </TitleContainerMobile>
              <SpecificationDesktop>
                <ProductDetails product={product} />
              </SpecificationDesktop>
            </LeftContainer>
            <RightContainer>
              <TitleContainerDesktop>
                <Title>{product.name}</Title>
              </TitleContainerDesktop>
              <StockBadge status={product.is_in_stock}>
                <StockBadgeDot status={product.is_in_stock} />
                {product.is_in_stock
                  .split("_")
                  .map((word) => word[0].toUpperCase() + word.slice(1))
                  .join(" ")}
              </StockBadge>
              <GridIcons>
                <GridIconsItem>
                  <GridIconsItemWrapper>
                    <h4>{t("PRODUCT.FLAVOR")}</h4>
                    <TextIconsP>{product.flavor}</TextIconsP>
                  </GridIconsItemWrapper>
                </GridIconsItem>

                <GridIconsItem>
                  <GridIconsItemWrapper>
                    <h4>{t("PRODUCT.STRENGTH_LABEL")}</h4>
                    <TextIconsP>
                      {" "}
                      {product.nicotine < 6
                        ? t("PRODUCT.STRENGTH.MILD")
                        : product.nicotine > 14
                        ? t("PRODUCT.STRENGTH.STRONG")
                        : t("PRODUCT.STRENGTH.REGULAR")}
                    </TextIconsP>
                  </GridIconsItemWrapper>
                </GridIconsItem>
                <GridIconsItem>
                  <GridIconsItemWrapper>
                    <h4>{t("PRODUCT.FORMAT")}</h4>
                    <TextIconsP>{product.format}</TextIconsP>
                  </GridIconsItemWrapper>
                </GridIconsItem>
                <GridIconsItem>
                  <GridIconsItemWrapper>
                    <h4>{t("PRODUCT.NICO_DOSE")}</h4>
                    <TextIconsP>{product.nicotine}MG</TextIconsP>
                  </GridIconsItemWrapper>
                </GridIconsItem>
              </GridIcons>

              <BuyCard>
              <GridQuantity role="radiogroup" aria-label={t("PRODUCT.QUANTITY")}>
                {[1, 10, 30, 50].map((quantity, index) => {
                  const { discountedPrice, savings } =
                    getDiscountData(quantity); // Calculate discount for each quantity
                  const isActive = selectedQuantity === quantity;

                  return (
                    <GridQuantityItem
                      key={index}
                      $isActive={isActive}
                      onClick={() => setSelectedQuantity(quantity)}
                      role="radio"
                      aria-checked={isActive}
                      tabIndex={0}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          setSelectedQuantity(quantity);
                        }
                      }}
                    >
                      <QuantityItemWrapper>
                        <FlexDiv
                          style={{
                            gap: "4px",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <RadioButton $isActive={isActive}>
                            <RadioInner />
                          </RadioButton>

                          {quantity != 1 ? (
                            <>
                              <span
                                style={{
                                  marginRight: "6px",
                                  fontWeight: "bold",
                                  color: "var(--text-100)",
                                }}
                              >
                                {t("PRODUCT.PACK", { quantity: quantity })}
                              </span>
                              <span>
                                {t("PRODUCT.PRICE_PER_PIECE", {
                                  currencyTag: currencyTag,
                                  discountedPrice: discountedPrice,
                                })}
                              </span>
                            </>
                          ) : (
                            <span
                              style={{
                                marginRight: "6px",
                                fontWeight: "bold",
                                color: "var(--text-100)",
                              }}
                            >
                              {t("PRODUCT.DOSE")}
                            </span>
                          )}
                        </FlexDiv>

                        <span>
                          <span>
                            {currencyTag}
                            {(
                              calculatePrice(product.price, quantity) * quantity
                            ).toFixed(2)}
                          </span>
                        </span>
                      </QuantityItemWrapper>
                    </GridQuantityItem>
                  );
                })}
              </GridQuantity>

              <ButtonContainer ref={addToCartRef}>
                <ButtonWrapper>
                  <Button
                    onClick={() => addToCart(selectedQuantity)}
                    disabled={product.is_in_stock === "out_of_stock"}
                  >
                    {product.is_in_stock === "out_of_stock"
                      ? t("BUTTONS.AVAILABLE_SOON")
                      : t("BUTTONS.ADD_TO_CART")}
                  </Button>

                  {isAnimating && (
                    <AddToCartAnim
                      isAnimating={isAnimating}
                      onComplete={handleAnimationComplete}
                    />
                  )}
                </ButtonWrapper>
                <SVGContainer
                  onClick={() => {
                    if (authTokens) {
                      toggleSaveForLater();
                    } else {
                      showLoginPopup();
                    }
                  }}
                  role="button"
                  tabIndex={0}
                  aria-label={
                    isSaved ? t("BUTTONS.REMOVE") : t("BUTTONS.SAVE_FOR_LATER")
                  }
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      if (authTokens) {
                        toggleSaveForLater();
                      } else {
                        showLoginPopup();
                      }
                    }
                  }}
                >
                  {isSaved ? (
                    <SaveForLaterSVG
                      width="30px"
                      height="30px"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.75 6L7.5 5.25H16.5L17.25 6V19.3162L12 16.2051L6.75 19.3162V6Z"
                        fill="var(--accent-200)"
                        stroke="var(--accent-200)"
                        strokeWidth="1"
                        strokeLinejoin="round"
                      />
                    </SaveForLaterSVG>
                  ) : (
                    <SaveForLaterSVG
                      width="30px"
                      height="30px"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M6.75 6L7.5 5.25H16.5L17.25 6V19.3162L12 16.2051L6.75 19.3162V6ZM8.25 6.75V16.6838L12 14.4615L15.75 16.6838V6.75H8.25Z"
                        fill="var(--text-200)"
                      />
                    </SaveForLaterSVG>
                  )}
                  <TooltipText>
                    {isSaved ? t("BUTTONS.REMOVE") : t("BUTTONS.SAVE_FOR_LATER")}
                  </TooltipText>
                </SVGContainer>
              </ButtonContainer>
              </BuyCard>

              <div
                style={{
                  backgroundColor: "var(--bg-200)",
                  padding: "18px",
                  borderRadius: "12px",
                  border: "1px solid var(--bg-300)",
                  order: "4",
                }}
              >
                <DescText>{shortDesc}</DescText>

                <BrT />

                <FlexDivIcons>
                  <IconDiv>
                    <SVGIcon
                      fill="var(--accent-200)"
                      height="24"
                      width="24"
                      version="1.1"
                      id="Layer_1"
                      viewBox="0 0 512.001 512.001"
                    >
                      <g>
                        <g>
                          <g>
                            <path
                              d="M466.395,88.411C395.95,69.109,325.091,39.054,261.478,1.496c-3.379-1.995-7.572-1.995-10.95,0
				C185.08,40.133,118.05,68.562,45.605,88.411c-4.68,1.281-7.924,5.535-7.924,10.388v110.046
				c0,113.323,52.279,188.335,96.137,231.306c47.216,46.265,102.216,71.85,122.185,71.85c19.967,0,74.967-25.585,122.183-71.85
				c43.857-42.97,96.133-117.982,96.133-231.306V98.798C474.319,93.946,471.075,89.692,466.395,88.411z M452.779,208.844
				c0,105.843-48.761,175.838-89.669,215.92c-46.431,45.495-96.074,65.695-107.107,65.695c-11.033,0-60.679-20.2-107.111-65.695
				c-40.907-40.083-89.67-110.077-89.67-215.92V106.974C128.5,87.304,193.018,59.853,256.005,23.25
				c61.414,35.632,129.151,64.448,196.774,83.72V208.844z"
                            />
                            <path
                              d="M160.538,105.769c-2.18-5.535-8.433-8.254-13.969-6.073c-19.24,7.581-38.988,14.559-58.695,20.741
				c-4.491,1.41-7.547,5.57-7.547,10.276v41.591c0,5.948,4.823,10.77,10.77,10.77s10.77-4.822,10.77-10.77v-33.72
				c17.679-5.72,35.339-12.047,52.598-18.848C160,117.557,162.719,111.304,160.538,105.769z"
                            />
                            <path
                              d="M180.997,107.812c1.445,0,2.912-0.291,4.319-0.905l0.198-0.086c5.449-2.388,7.903-8.731,5.515-14.178
				c-2.39-5.449-8.769-7.914-14.212-5.528l-0.174,0.075c-5.452,2.381-7.914,8.719-5.533,14.169
				C172.877,105.405,176.842,107.812,180.997,107.812z"
                            />
                            <path
                              d="M384.322,347.283c-4.977-3.253-11.651-1.854-14.908,3.125c-8.875,13.584-19.287,26.592-30.951,38.659
				c-9.592,9.922-19.986,19.17-30.893,27.485c-4.729,3.606-5.639,10.364-2.034,15.095c2.121,2.779,5.328,4.241,8.572,4.241
				c2.278,0,4.573-0.719,6.523-2.207c11.765-8.971,22.975-18.944,33.317-29.642c12.611-13.044,23.881-27.124,33.499-41.849
				C390.702,357.21,389.301,350.536,384.322,347.283z"
                            />
                            <path
                              d="M282.558,433.443l-0.618,0.364c-5.147,2.981-6.906,9.569-3.926,14.716c1.997,3.45,5.612,5.376,9.331,5.376
				c1.83,0,3.688-0.467,5.385-1.452l0.713-0.419c5.133-3.006,6.857-9.603,3.851-14.736
				C294.286,432.161,287.688,430.44,282.558,433.443z"
                            />
                            <path
                              d="M182.589,234.019c-6.613-6.614-15.408-10.254-24.762-10.254s-18.15,3.641-24.766,10.254
				c-13.653,13.656-13.653,35.876,0,49.531l63.596,63.594c6.614,6.612,15.409,10.253,24.764,10.253s18.15-3.641,24.765-10.255
				L378.947,214.38c13.652-13.659,13.652-35.876-0.002-49.527c-6.614-6.614-15.409-10.254-24.765-10.254
				c-9.355,0-18.15,3.641-24.765,10.254L221.42,272.848L182.589,234.019z M344.647,180.085c2.545-2.545,5.932-3.946,9.534-3.946
				c3.604,0,6.988,1.401,9.535,3.946c5.255,5.255,5.255,13.809-0.002,19.066l-132.759,132.76c-2.545,2.545-5.932,3.946-9.534,3.946
				s-6.989-1.401-9.535-3.946l-63.594-63.592c-5.257-5.257-5.257-13.811-0.002-19.066c2.546-2.545,5.933-3.948,9.536-3.948
				s6.988,1.401,9.533,3.946l46.445,46.446c2.021,2.019,4.759,3.154,7.616,3.154s5.595-1.134,7.614-3.154L344.647,180.085z"
                            />
                          </g>
                        </g>
                      </g>
                    </SVGIcon>
                    <IconText>{t("PRODUCT.SECURE_PAYMENTS")}</IconText>
                  </IconDiv>
                  <IconDiv>
                    <SVGIcon
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M14.7667 2.50445L14.1843 2.84068H10.3906C10.1835 2.84068 10.0156 3.00859 10.0156 3.21568C10.0156 3.42278 10.1835 3.59068 10.3906 3.59068H12.8853L12.1697 4.00379L20.5891 8.86478V12.4667C20.5891 12.6107 20.5178 12.7343 20.3931 12.8063L18.4415 13.933C18.3792 13.969 18.3078 13.969 18.2455 13.933C18.1831 13.897 18.1475 13.8352 18.1475 13.7633V10.2744L9.72816 5.41342L7.34442 6.78967C7.30214 6.77312 7.25616 6.76407 7.20802 6.76407H0.796922C0.589828 6.76407 0.421922 6.93198 0.421922 7.13907C0.421922 7.34617 0.589828 7.51407 0.796922 7.51407H6.74278C6.74044 7.53957 6.73922 7.5655 6.73922 7.59175V11.6251H3.02902C2.82192 11.6251 2.65402 11.793 2.65402 12.0001C2.65402 12.2072 2.82192 12.3751 3.02902 12.3751H6.73922V16.0172H0.796875C0.589781 16.0172 0.421875 16.1852 0.421875 16.3922C0.421875 16.5993 0.589781 16.7672 0.796875 16.7672H6.82294C6.88955 16.8982 6.99431 17.0083 7.13123 17.0874L14.7667 21.4957C15.016 21.6397 15.3014 21.6397 15.5507 21.4957L23.1861 17.0874C23.4354 16.9435 23.5781 16.6963 23.5781 16.4084V7.59175C23.5781 7.30389 23.4354 7.05671 23.1861 6.91276L15.5506 2.50445C15.3014 2.3605 15.016 2.3605 14.7667 2.50445ZM7.57317 2.84064C7.78027 2.84064 7.94817 3.00854 7.94817 3.21564C7.94817 3.42273 7.78027 3.59064 7.57317 3.59064H2.56031C2.35322 3.59064 2.18531 3.42273 2.18531 3.21564C2.18531 3.00854 2.35322 2.84064 2.56031 2.84064H7.57317Z"
                        fill="var(--accent-200)"
                      />
                    </SVGIcon>
                    <IconText>{t("PRODUCT.LOWEST_PRICE")}</IconText>
                  </IconDiv>
                  <IconDiv>
                    <SVGIcon
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M22.6985 14.4272H23.4375V12.1919C23.4375 12.0767 23.4173 11.9782 23.3717 11.8708L21.8297 8.2401C21.6816 7.89135 21.3323 7.67291 20.9226 7.67291H17.3768V17.2668H17.7274C17.7274 15.9941 18.7595 14.962 20.0321 14.962C21.3048 14.962 22.3369 15.9942 22.3369 17.2668H22.8544C23.1755 17.2668 23.4374 17.0049 23.4374 16.6837V15.8832H22.6984C22.5504 15.8832 22.4296 15.7625 22.4296 15.6144V14.6959C22.4297 14.5479 22.5504 14.4272 22.6985 14.4272ZM17.8218 11.9016V8.86789H20.7981L22.0865 11.9016H17.8218ZM15.8495 5.17822C11.4575 5.17822 7.06552 5.17822 2.67356 5.17822C2.46647 5.17822 2.29856 5.34613 2.29856 5.55322C2.29856 5.76032 2.46647 5.92822 2.67356 5.92822H4.75181C5.11598 5.92822 5.41392 6.22616 5.41392 6.59033C5.41392 6.9545 5.11598 7.25244 4.75181 7.25244H1.4393H0.9375C0.730406 7.25244 0.5625 7.42035 0.5625 7.62744C0.5625 7.83453 0.730406 8.00244 0.9375 8.00244H4.15823C4.52241 8.00244 4.82034 8.30038 4.82034 8.66455C4.82034 9.02872 4.52241 9.32666 4.15823 9.32666H1.99303C1.78594 9.32666 1.61803 9.49457 1.61803 9.70166C1.61803 9.90875 1.78594 10.0767 1.99303 10.0767H5.10694C5.47111 10.0767 5.76905 10.3746 5.76905 10.7388C5.76905 11.1029 5.47111 11.4009 5.10694 11.4009C3.71714 11.4009 2.3273 11.4008 0.9375 11.4009C0.730406 11.4009 0.5625 11.5688 0.5625 11.7759C0.5625 11.983 0.730406 12.1509 0.9375 12.1509H4.15823V16.4895C4.15823 16.9176 4.50745 17.2669 4.93561 17.2669H6.54398C6.54398 15.9942 7.57612 14.9621 8.84873 14.9621C10.1214 14.9621 11.1535 15.9942 11.1535 17.2669H16.6268V5.9556C16.6268 5.52744 16.2776 5.17822 15.8495 5.17822ZM10.7812 14.2861C9.00075 14.2861 7.55742 12.8428 7.55742 11.0623C7.55742 9.28189 9.00075 7.83857 10.7812 7.83857C12.5617 7.83857 14.005 9.28189 14.005 11.0623C14.005 12.8428 12.5617 14.2861 10.7812 14.2861ZM10.3578 11.3467L11.9253 9.76349C12.1109 9.57608 12.4136 9.57557 12.6005 9.76138C12.7873 9.94714 12.7879 10.249 12.6025 10.4361C11.9669 11.0776 11.3355 11.7234 10.6969 12.3621C10.5102 12.5488 10.2074 12.5488 10.0207 12.3621L8.96124 11.3026C8.77453 11.1159 8.77453 10.8131 8.96124 10.6264C9.14794 10.4397 9.45075 10.4397 9.63745 10.6264L10.3578 11.3467ZM8.84878 15.712C7.99008 15.712 7.29403 16.4081 7.29403 17.2668C7.29403 18.1255 7.99013 18.8216 8.84878 18.8216C9.70748 18.8216 10.4036 18.1255 10.4036 17.2668C10.4036 16.4081 9.70748 15.712 8.84878 15.712ZM8.84878 17.7965C8.556 17.7965 8.31905 17.5596 8.31905 17.2668C8.31905 16.974 8.556 16.7371 8.84878 16.7371C9.14156 16.7371 9.37852 16.974 9.37852 17.2668C9.37852 17.5596 9.14156 17.7965 8.84878 17.7965ZM20.0322 15.712C19.1735 15.712 18.4774 16.4081 18.4774 17.2668C18.4774 18.1255 19.1735 18.8216 20.0322 18.8216C20.8909 18.8216 21.5869 18.1255 21.5869 17.2668C21.587 16.4081 20.8909 15.712 20.0322 15.712ZM20.0322 17.7965C19.7394 17.7965 19.5024 17.5596 19.5024 17.2668C19.5024 16.974 19.7394 16.7371 20.0322 16.7371C20.325 16.7371 20.5619 16.974 20.5619 17.2668C20.5619 17.5596 20.325 17.7965 20.0322 17.7965Z"
                        fill="var(--accent-200)"
                      />
                    </SVGIcon>
                    <IconText>{t("PRODUCT.SATISFACTION_GUARANTEED")}</IconText>
                  </IconDiv>
                </FlexDivIcons>
              </div>

              <BrT />
            </RightContainer>
            <SpecificationMobile>
              <ProductDetails product={product} />
            </SpecificationMobile>
          </Wrapper>
          <StickyBar $visible={!isMainButtonVisible}>
            <StickyBarPrice>
              {currencyTag}
              {(
                calculatePrice(product.price, selectedQuantity) *
                selectedQuantity
              ).toFixed(2)}
            </StickyBarPrice>
            <StickyBarButton
              onClick={() => addToCart(selectedQuantity)}
              disabled={product.is_in_stock === "out_of_stock"}
            >
              {product.is_in_stock === "out_of_stock"
                ? t("BUTTONS.AVAILABLE_SOON")
                : t("BUTTONS.ADD_TO_CART")}
            </StickyBarButton>
          </StickyBar>
        </>
      )}
      {!product && !loadError && <LoadingState>{t("loading")}</LoadingState>}
      {!product && loadError && (
        <LoadingState>{t("NOTIFICATIONS.ERROR")}</LoadingState>
      )}
    </Container>
  );
};

export default ProductMain;
